import React, { FC } from 'react'

import { IconHelpAtHandProps } from './IconHelpAtHand.types'
import * as Styled from './styles/IconHelpAtHand.style'

import { nonThemeableRules } from '../../ruleSet'

const IconHelpAtHand: FC<IconHelpAtHandProps> = ({
  size = nonThemeableRules.defaultSize as number as IconHelpAtHandProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconHelpAtHandProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='m159.77 70.65-10-28A4 4 0 0 0 146 40h-42a16 16 0 0 0-16-16H16A16 16 0 0 0 0 40v56a16 16 0 0 0 16 16 16.29 16.29 0 0 0 15.92 16h.17A16.28 16.28 0 0 0 48 112h55.67a16 16 0 0 0 32 0H144a16 16 0 0 0 16-16V72a4 4 0 0 0-.23-1.35zM96 104H43.51a4 4 0 0 0-3.86 5.06 9.75 9.75 0 0 1 .35 2.52 8.27 8.27 0 0 1-8 8.42 8.29 8.29 0 0 1-8-8.5 9 9 0 0 1 .33-2.42 4 4 0 0 0-3.85-5.08H16a8 8 0 0 1-8-8V40a8 8 0 0 1 8-8h72a8 8 0 0 1 8 8zm56-8a8 8 0 0 1-8 8h-12.79a4.07 4.07 0 0 0-4 4.08 4 4 0 0 0 .08.81 20 20 0 0 1 .37 2.72 8 8 0 0 1-16-.12 9 9 0 0 1 .33-2.41 4 4 0 0 0-3.86-5.07H104V48h39.18L152 72.69z' />
        <path d='M68 64H56V52a4 4 0 0 0-8 0v12H36a4 4 0 0 0 0 8h12v12a4 4 0 0 0 8 0V72h12a4 4 0 0 0 0-8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconHelpAtHand
